import React from 'react'
import "./Contactus.css";
import Mail from "../images/mailicon.jpg";
import Call from "../images/CALL.jpg";
import { Link } from "react-router-dom";
import Youtube from "../images/youtube-icon.jpg";
import Facebookicon from "../images/facebook-icon.jpg";
import ScrollToTop from "react-scroll-to-top";

import AddStore from '../AddStore';

import Headern from '../inc/Headern';

function Contactus() {
  return (
    <div>
      <Headern />
      <br />
      <br />
      <br />
      <br />
<br/>


      <ScrollToTop smooth top="100" color="grey" />
      <div className='newback'>
        <div className="album py-1">

          <div className="container mt-3">

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="album py-3">

        <div className="container">
          <h1 style={{ color: "maroon" }}><b>Contact us</b></h1>
          <p className='mb-2'>We’re here to help you. Get in touch with us from any of these ways:</p>
          <a style={{ color: "maroon" }} href='mailto: info@thelovebirdsicecream.com'><small>Email: info@thelovebirdsicecream.com </small></a>
          <hr className='' style={{ color: "grey" }} />
        </div>
      </div>


      <div className="container">

        <div className="row">

          <div className="col-md-3 mt-2">
            <div className="card">
              <a href='mailto: thelovebirds22@gmail.com'>
                <img src={Mail} className="card-img-top mb-0" alt="Mail" />
                <div className="card-body">
                  <center>
                    <h6 style={{ color: "grey" }} className="card-title mb-0"><small>Write to us</small></h6>
                    <p style={{ color: "grey" }} className="card-text"><small>your valuable feedback</small></p>
                  </center>
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3 mt-2">
            <div className="card">
              <a href='https://www.youtube.com/@thelovebirds22' target="_blank" rel="noopener noreferrer">
                <img src={Youtube} className="card-img-top" alt="Youtube" />
                <div className="card-body">
                  <center>
                    <h6 style={{ color: "grey" }} className="card-title mb-0"><small>update</small></h6>
                    <p style={{ color: "grey" }} className="card-text"><small>Connect with us on your favourite social network.</small></p>
                  </center>
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3 mt-2">
            <div className="card">
              <a href='https://www.facebook.com/p/The-Love-Birds-100083168470438/' target="_blank" rel="noopener noreferrer">
                <img src={Facebookicon} className="card-img-top" alt="Facebookicon" />
                <div className="card-body">
                  <center>
                    <h6 style={{ color: "grey" }} className="card-title mb-0"><small>the-love-birds</small></h6>
                    <p style={{ color: "grey" }} className="card-text"><small>Connect with us on your favourite social network.</small></p>
                  </center>
                </div>
              </a>
            </div>
          </div>
          <div className="col-md-3 mt-2">
            <div className="card">
              <a href='tel:  +91 7031820115'>
                <img src={Call} className="card-img-top" alt="manmohini_contact" />
                <div className="card-body">
                  <center>
                    <h6 style={{ color: "grey" }} className="card-title mb-0"><small>Talk to us</small></h6>
                    <p style={{ color: "grey" }} className="card-text mb-0"><small>Everyday 12:00AM to 09:00PM</small></p>
                    <p style={{ color: "grey" }} className="card-text"><small>  Call us on  +91 70318 20115</small></p>

                  </center>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <br />

      <div className='album py-1'>
        <div className="container">

          <div className="row">
            <h6 className='mb-3' style={{ color: "grey" }}>Your feedback is about our:</h6>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true"><small>In-Store experience</small></button>
              </li>

              <li className="nav-item" role="presentation">
                <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false"><small>Help Line</small></button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                <br />
                <AddStore />
              </div>

              <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                <br />
                <p className='mt-2 mb-3'>Any query please cantact : - </p>
                <a style={{ color: "grey" }} href='tel: 7031820115'>
                  <p className='mb-1'>+91  +91 70318 20115</p>
                </a>
                <a style={{ color: "grey" }} href='mailto: thelovebirds22@gmail.com'>thelovebirds22@gmail.com</a>
                <br />
                <a style={{ color: "grey" }} href='mailto: info@thelovebirdsicecream.com'><small> info@thelovebirdsicecream.com </small></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />

      <div className="album py-2">
                <div className="container">
                    <div className="row">
                    <iframe className="iframe-fluid mb-2"  height="380" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=The%20Love%20Bird's,%20Rajani%20Mukherjee%20Ln,%20%5Bno%20name%5D,%20Krishnanagar,%20West%20Bengal%20741101%20+(The%20Love%20Bird's,%20Rajani%20Mukherjee%20Ln,%20%5Bno%20name%5D,%20Krishnanagar,%20West%20Bengal%20741101)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>

                        
                    </div>
                </div>
            </div>
      <br/>

    </div>



  )
}

export default Contactus